import { ReportResultBaseModel } from '@treasury/domain/reports/report-results.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-summary-tile';
// eslint-disable-next-line no-duplicate-imports
import { type SummaryTileVm } from '@treasury/presentation/components/tm-summary-tile';
import { formatUsdCurrency } from '@treasury/utils';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

export const tagName = 'balance-report-summary';
@customElement(tagName)
export class BalanceReportSummary extends TmBaseComponent {
    @property()
    public report?: ReportResultBaseModel;

    @state()
    private selectedTile?: SummaryTileVm;

    public render() {
        if (!this.report) {
            return nothing;
        }
        if (this.report.dateType === 'Date Range') {
            return nothing;
        }
        return html`<div class="flex w-full justify-around">
            <tm-summary-tile
                .summaryTile=${{
                    id: 'Checking',
                    title: 'Total Checking Balance',
                    totalAmount: formatUsdCurrency(this.report.totalCheckingBalance || 0),
                    count: this.report.totalCheckingBalanceCount,
                }}
                .isSelected=${this.selectedTile?.title === 'Total Checking Balance'}
                @tileClicked=${this.handleTileSelection}
            ></tm-summary-tile>
            <tm-summary-tile
                .summaryTile=${{
                    id: 'Savings',
                    title: 'Total Savings Balance',
                    totalAmount: formatUsdCurrency(this.report.totalSavingsBalance || 0),
                    count: this.report.totalSavingsBalanceCount,
                }}
                .isSelected=${this.selectedTile?.title === 'Total Savings Balance'}
                @tileClicked=${this.handleTileSelection}
            ></tm-summary-tile>
        </div>`;
    }

    public get filterOn() {
        if (this.selectedTile) {
            return {
                key: 'accountType',
                value: this.selectedTile.id,
            };
        }
        return undefined;
    }

    private handleTileSelection(e: CustomEvent) {
        if (!e.detail) {
            return;
        }
        if (this.selectedTile?.title === e.detail.title) {
            this.selectedTile = undefined;
        } else {
            this.selectedTile = e.detail;
        }
        this.dispatchEvent(
            new CustomEvent('filter-tile-changed', {
                detail: this.filterOn,
                bubbles: true,
                composed: true,
            })
        );
    }
}
